export default "__VITE_ASSET__DJYB_JBu__"